import {
  IDateTimepickerFieldConfigurationClient,
  IDateTimepickerFieldConfigurationServer,
} from "./interface";

export const transformDateTimeInputFieldConfigClientToServer = (
  fieldConfigClient: IDateTimepickerFieldConfigurationClient
): IDateTimepickerFieldConfigurationServer => {
  const { initialValue, writeJavascript, isCurrentDateTimeSelected, dateTimeInitialValueType } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    writeJavascript: writeJavascript, 
    isCurrentDateTimeSelected: isCurrentDateTimeSelected,
    dateTimeInitialValueType: dateTimeInitialValueType
	
  };
  return fieldConfigServer;
};

export const transformDateTimeInputConfigServerToClient = (
  fieldConfigServer: IDateTimepickerFieldConfigurationServer
): IDateTimepickerFieldConfigurationClient => {
  const { initialValue, writeJavascript, isCurrentDateTimeSelected, dateTimeInitialValueType } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    isCurrentDateTimeSelected: isCurrentDateTimeSelected,
    dateTimeInitialValueType: dateTimeInitialValueType
  };
  return fieldConfigClient;
};

export const setInitialValue = "Set Initial Value";
export const currentDateTime = "Current Date Time";
